import { provideAppInitializer } from '@angular/core';
import { inject } from '@angular/core';
import { EnvironmentService } from '../services/environment.service';
import { AppConfigService } from 'src/app/services/app-config.service';
import { ApplicationInsightsService } from 'src/app/services/application-insights.service';

export const ENVIRONMENT_PROVIDERS = [
  provideAppInitializer(() => {
    const initializerFn = ((appConfigService: AppConfigService,
      applicationInsightsService: ApplicationInsightsService,
      environmentService: EnvironmentService) => {
      return async () => {
        // First, load the app config
        await environmentService.loadEnvironment();
        await appConfigService.loadConfig();
        // Then, initialize Application Insights with the loaded config
        await applicationInsightsService.initialize();
      };
    })(inject(AppConfigService), inject(ApplicationInsightsService), inject(EnvironmentService));
    return initializerFn();
  })
];